<tps-assistant-form-shell [submissionState]="submissionState()" [errorMessage]="errorMessage()">
  <div assistantFormHeader>{{ i18n.translate('task:createNewTask')() }}</div>

  <ngt-input-field assistantFormFields [mode]="blocked() ? 'disabled' : 'active'" [label]="i18n.translate('task:title')()" [value]="title()" (valueChange)="setTitle($event)" width="max" />
  <ngt-date-input assistantFormFields [mode]="blocked() ? 'disabled' : 'active'" [label]="i18n.translate('task:dueDate')()" [value]="dueDate()" (valueChange)="setDueDate($event)" width="max" class="ngt-width-max" />
  <ngt-select-dropdown assistantFormFields [mode]="blocked() ? 'disabled' : 'active'" [value]="priority()" (valueChange)="setPriority($event)" [options]="priorityOptions()" width="max" class="ngt-width-max" />
  <ngt-input-field assistantFormFields [mode]="blocked() ? 'disabled' : 'active'" [label]="i18n.translate('task:description')()" [value]="description()" (valueChange)="setDescription($event)" width="max" />

  <div assistantFormActions>
    @if (submissionState() === 'idle') {
      <ngt-button (click)="createTask()">{{ i18n.translate('task:createTask')() }}</ngt-button>
    }
  </div>
</tps-assistant-form-shell>
